import validate from "/Users/noah/Documents/websites/ch4pathways-org-website-frontend/node_modules/nuxt/dist/pages/runtime/validate.js";
export const globalMiddleware = [
  validate
]
export const namedMiddleware = {}